// extracted by mini-css-extract-plugin
export var content = "VerticalIconsSteps-module--content--9712b";
export var icon = "VerticalIconsSteps-module--icon--7705e";
export var step = "VerticalIconsSteps-module--step--f3153";
export var steps = "VerticalIconsSteps-module--steps--4d54d";